import { useState, useEffect } from 'react'
import { Venda, mockVendas, mockKPIResumo } from '../utils/mockData'

import { API_BASE } from '../config'

export interface KPIResumo {
  faturamento_total: number
  valor_caixa_total: number
  gap: number
  gap_pct: number
  num_vendas: number
  num_vendedores: number
  ticket_medio: number
  inadimplencia: number
  taxa_recebimento: number
}

export function useVendas(mes?: number, ano?: number) {
  const [vendas, setVendas] = useState<Venda[]>([])
  const [kpi, setKPI] = useState<KPIResumo | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    fetchVendas()
    fetchKPI()
  }, [mes, ano])

  async function fetchVendas() {
    try {
      setLoading(true)
      setError(null)

      const query = new URLSearchParams()
      if (mes) query.append('mes', mes.toString())
      if (ano) query.append('ano', ano.toString())

      const response = await fetch(`${API_BASE}/api/vendas?${query}`)

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`)
      }

      const data = await response.json()

      if (data.success && data.data) {
        setVendas(data.data)
      } else {
        // Fallback to mock data se houver erro
        console.warn('Usando mock data:', data.error)
        setVendas(mockVendas)
      }
    } catch (err) {
      console.error('Erro ao buscar vendas:', err)
      // Usar mock data em caso de erro
      setVendas(mockVendas)
      setError(err instanceof Error ? err.message : 'Erro desconhecido')
    } finally {
      setLoading(false)
    }
  }

  async function fetchKPI() {
    try {
      const query = new URLSearchParams()
      if (mes) query.append('mes', mes.toString())
      if (ano) query.append('ano', ano.toString())

      const response = await fetch(`${API_BASE}/api/kpis/resumo?${query}`)

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`)
      }

      const data = await response.json()

      if (data.success && data.data) {
        setKPI(data.data)
      } else {
        console.warn('Usando mock KPI:', data.error)
        setKPI(mockKPIResumo)
      }
    } catch (err) {
      console.error('Erro ao buscar KPI:', err)
      // Usar mock KPI em caso de erro
      setKPI(mockKPIResumo)
    }
  }

  return { vendas, kpi, loading, error, refetch: fetchVendas }
}
